import { useCallback, useRef, useState } from 'react';
import { DEFAULT_WALLET_CONNECTION } from '../constants';
export function useWalletConnection() {
    const prevWalletConnection = useRef(DEFAULT_WALLET_CONNECTION);
    const [walletConnection, setWalletConnectionRaw] = useState(DEFAULT_WALLET_CONNECTION);
    const setWalletConnection = useCallback((newInfo) => {
        if (prevWalletConnection.current.wallet != newInfo.wallet ||
            prevWalletConnection.current.network != newInfo.network ||
            prevWalletConnection.current.address != newInfo.address ||
            prevWalletConnection.current.connectionState != newInfo.connectionState) {
            prevWalletConnection.current = newInfo;
            setWalletConnectionRaw(newInfo);
        }
    }, []);
    return { walletConnection, setWalletConnection };
}
